import * as React from 'react';
import { useState, useEffect, useRef } from 'react';

import * as classnames from 'classnames';
import { Tooltip } from 'common--design-library';
import * as localization from 'easit--localization';


export interface IEventRateProps {
    oddKey: string; // originally key, but it does not come here as key is reserved for unique id of item instance
    ident: string;
    name: string;
    rate: number;
    popularity?: number;
    showPopularity?: boolean;
    isHighlighted?: boolean;
    active?: boolean; //aktivni na aktualni zalozce ticketu
    inactive?: boolean; //aktivni na jine zalozce ticketu ale je vybrane
    onClick?: (ident: string) => void;
    isSuspended: boolean;
    className?: string;
    showTipsInside?: boolean;
    roleForTest?: string;
    tooltipIdPrefix: string | null;  // null means do not show
}

function usePrevious(value: any) {
    const ref = useRef();
    useEffect(() => {
        ref.current = value;
    }, [value]); // Only re-run if value changes

    return ref.current;
}

export const EventRate = (props: IEventRateProps) => {

    //!! similar in EventRate.tsx, ticketTip.tsx, eventRateComponent.tsx and EventRateChangeMonitoringWrapper as "generic"

    const [repeatChange, setRepeatChange] = useState<boolean>(false);
    const [changeClass, setChangeClass] = useState<string>('');
    const [lastChangeTime, setLastChangeTime] = useState<number>(0);
    const prevRate = usePrevious(props.rate) || 0;

    const getToolTipId = () => {
        return `tooltip_${props.tooltipIdPrefix}_${props.oddKey.replace(".", "")}`;
    }

    useEffect(() => {
        if (prevRate && props.rate) {
            const newTime = new Date().getTime();
            if (prevRate === props.rate) {
                if (newTime > (lastChangeTime + 10000)) {
                    setChangeClass('');
                }
            }
            else {
                let change = changeClass;
                setLastChangeTime(newTime);
                if (props.rate < prevRate) {
                    change = ' changed-down';
                } else if (props.rate > prevRate) {
                    change = ' changed-up';
                }

                change += repeatChange ? ' blink-me-r' : ' blink-me';
                setRepeatChange(!repeatChange);
                setChangeClass(change);
            }
        }
    }/* no, otherwise it does not hide , [props.rate]*/);

    return (
        <div
            className={classnames('rate-btn', { inactive: props.inactive }, { active: props.active }, { highlighted: props.isHighlighted }, { suspended: props.isSuspended }, props.className && props.className)}
            onClick={event => {
                event.stopPropagation();
                props && !props.isSuspended && props.onClick(props.ident);
            }}
            data-test-role={props.roleForTest}
        >
            {
                props.isSuspended &&
                <span className="fa fa-lock rate-lock"></span>
            }
            {
                props.showTipsInside
                    ? <div
                        className="rate d-flex align-items-center justify-content-between tip-inside">
                        {
                            changeClass !== '' &&
                            <span className={`rate-changed ${changeClass}`}></span>
                        }
                        {props.tooltipIdPrefix && props.name.length > 10
                            ? <Tooltip
                                targetid={getToolTipId()} placement="top" autohide={false}
                                targetFactory={(p) => <div {...p} className="tip-label text-truncate">{props.name}</div>}
                            >
                                {props.name}
                            </Tooltip>
                            :
                            <div className="tip-label text-truncate">{props.name}</div>
                        }


                        <span className="tip-rate">{props.rate && !props.isSuspended ? localization.numberFormatter.format(props.rate) : null}</span>
                    </div>
                    : <>
                        {props.tooltipIdPrefix && props.name.length > 10
                            ? <Tooltip
                                targetid={getToolTipId()} placement="top" autohide={false}
                                targetFactory={(p) => <div {...p} className="rate-label text-truncate">{props.name}</div>}
                            >
                                {props.name}
                            </Tooltip>
                            :
                            <div className="rate-label text-truncate">{props.name}</div>
                        }
                        <div
                            className="rate d-flex align-items-center justify-content-center"
                        >
                            {props.showPopularity ? (
                                <div className="w-100">
                                    <div>
                                        {
                                            changeClass !== '' &&
                                            <span className={`rate-changed ${changeClass}`}></span>
                                        }
                                        {props.rate && !props.isSuspended ? localization.numberFormatter.format(props.rate) : null}
                                    </div>
                                    <div className="rate-popularity">
                                        <div className="popularity-value" style={{ width: `${props.popularity}%` }} />
                                    </div>
                                </div>
                            ) : (
                                <>
                                    {
                                        changeClass !== '' &&
                                        <span className={`rate-changed ${changeClass}`}></span>
                                    }
                                    {props.rate && !props.isSuspended ? localization.numberFormatter.format(props.rate) : <>&nbsp;</>  /* nbsp for mobile to have the second row */}
                                </>
                            )}
                        </div>
                    </>
            }


        </div>
    );

};
